<template>
    <v-combobox
            ref="searchInput"
            auto-select-first
            :menu-props="{ auto: false}"
            flat
            outlined
            clearable
            v-model="model"
            :disabled="loadingCreate"
            :items="items"
            :loading="loading || loadingCreate"
            :search-input.sync="search"
            :error-messages="shouldCreate ? 'Diagnóstico no encontrado' : (errorMessages || null)"
            :filter="() => true"
            color="primary"
            item-text="title"
            item-value="id"
            :label="label || 'Buscar diagnóstico'"
            @click:clear="clearSearch"
            return-object
    >
        <template slot="no-data">
            <span class="caption pa-2">Diagnóstico no encontrado:
            <v-btn
                    :disabled="!shouldCreate"
                    color="primary"
                    rounded small
                    :loading="loadingCreate"
                    depressed
                    @click="createDiagnosis">crearlo</v-btn>
            </span>
        </template>

        <template v-slot:item="data">
            <template v-if="typeof data.item !== 'object'">
                <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
                <v-list-item-content v-text="data.item.title"></v-list-item-content>
            </template>
        </template>
    </v-combobox>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {debounce} from '@/utils/Common'

    import {mapState, mapMutations} from 'vuex'

    export default{
        props: ['value', 'errorMessages', 'label', 'attach'],
        data(){
            return {
                descriptionLimit: 60,
                diagnoses: [],
                loading: false,
                loadingCreate: false,

                search: '',
                model: null,
            }
        },
        mounted(){
            this.getItems()
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            clearSearch(){
                var vm = this
                vm.search = ''
                vm.model = null
                vm.$refs.searchInput.blur()
            },
            async createDiagnosis(){
                var vm =this

                if(vm.search.length < 3){
                    vm.showSnackBar('El texto debe contener al menos 3 caracteres')
                    return
                }

                if(!vm.currentProvider){
                    throw new Error('No provider selected')
                }

                 vm.loadingCreate = true
                const response = await ApiUtils.makePost(`providers/${vm.currentProvider.id}/diagnosis`, {
                    name: vm.search
                })
                 vm.loadingCreate = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando crear el diagnóstico')
                    vm.$emit('error', json)
                    return
                }

                const json = await response.json()
                vm.diagnoses.push(json.result.diagnosis)
                vm.clearSearch()
                vm.$nextTick(async function(){

                    const createdModel = {
                        id: json.result.diagnosis.id,
                        title: json.result.diagnosis.name,
                    }

                    vm.$emit('change', createdModel)
                    vm.$nextTick(function(){
                        vm.clearSearch()
                    })
                })

            },
            debounceGetItems: debounce(function(){
                this.getItems()
            }, 300),
            async getItems(){

                var vm = this

                if(!vm.currentProvider){
                    throw new Error('No provider selected')
                }

                vm.loading = true
                const response = await ApiUtils.makeGet(`providers/${vm.currentProvider.id}/diagnoses`, {
                    term: vm.search
                })
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error consultando diagnósticos')
                    return
                }

                const json = await response.json()
                vm.diagnoses = json.result.diagnoses.data

               vm.$nextTick(function(){
                   if(vm.value){
                       vm.model = vm.value
                   }
               })

            }
        },
        computed: {
            ...mapState(['currentProvider']),
            shouldCreate(){
                return this.search && this.diagnoses.length === 0 && (!this.model || typeof this.model === 'string') && !this.loading
            },
            items () {
                return this.diagnoses.map(diagnosis => {
                    return {
                        id: diagnosis.id,
                        title: diagnosis.name,
                    }
                })
            }
        },
        watch: {
            search (val) {
                var vm = this
                if(vm.model && val === vm.model.title) return
                vm.model = null
                vm.debounceGetItems()
            },
            value(val){
                this.model = val
            },
            model(val){
                const vm = this
                const newModel = typeof val === 'string' ? null : val
                vm.$emit('change', newModel)
                if(val){
                  vm.$nextTick(() => {
                    vm.clearSearch()
                  })
                }
            }
        }
    }
</script>
